import { promoRestrictedGroups, someGroupMember, USER_GROUP } from './user';
import { User } from '@/api/auth';

export const checkIsCmsPromoAvailable = (
  isAvailableByDate?: boolean,
  user?: User,
  restrictedGroups?: USER_GROUP[]
) => {
  if (!isAvailableByDate) return false;

  const groups = restrictedGroups ?? promoRestrictedGroups;
  return !someGroupMember(groups)(user);
};
